import React from 'react';

import { UserIcon } from '../icons/ChatCategoryIcons';


const InviteAccountCard = ({ onOpen }) => (
  <section className="subpage-card subpage-invite-card">
    <div className="subpage-invite-summary">
      <div className="subpage-invite-icon" aria-hidden="true">
        <UserIcon size={24} color="var(--whatquiz-primary)" />
      </div>
      <div>
        <h2 className="subpage-invite-title">친구 초대</h2>
        <p className="subpage-invite-description">
          내 초대 현황을 보고 동료 선생님께 다시 공유해요.
        </p>
      </div>
    </div>
    <button
      className="subpage-invite-button"
      onClick={onOpen}
      type="button"
    >
      초대 링크 보기
    </button>
  </section>
);

export default InviteAccountCard;
